
var SRP6CryptoParams = {
  N_base10: "21766174458617435773191008891802753781907668374255538511144643224689886235383840957210909013086056401571399717235807266581649606472148410291413364152197364477180887395655483738115072677402235101762521901569820740293149529620419333266262073471054548368736039519702486226506248861060256971802984953561121442680157668000761429988222457090413873973970171927093992114751765168063614761119615476233422096442783117971236371647333871414335895773474667308967050807005509320424799678417036867928316761272274230314067548291133582479583061439577559347101961771406173684378522703483495337037655006751328447510550299250924469288819",
  g_base10: "2",
  k_base16: "5b9e8ef059c6b32ea59fc1d322d37f04aa30bae5aa9003b8321e21ddb04e300",
  salt: "4b875c24c5ff7709e354c3c304fd70d2"
};

// Первоначальные установки получаемые с сервера
var prefsSRP = new gadgets.Prefs("__MODULE_ID__");
var gPrefsSRP = gadgets.util.unescapeString(prefsSRP.getString("inputData"));

var srp_prefs = {
  "n": SRP6CryptoParams.N_base10,
  "g": SRP6CryptoParams.g_base10,
  "k": SRP6CryptoParams.k_base16,
  "h": "SHA256"
};

if (gPrefsSRP !== "") {
  srp_prefs = JSON.parse(gPrefsSRP);

  if (typeof srp_prefs.view != 'undefined' && typeof srp_prefs.view.srp_challenge != 'undefined') {


    SRP6CryptoParams = {
      N_base10: srp_prefs.view.srp_challenge["n"],
      g_base10: srp_prefs.view.srp_challenge["g"],
      k_base16: srp_prefs.view.srp_challenge["k"]
    };

  }
}
window.srp_prefs = srp_prefs;
window.SRP6CryptoParams = SRP6CryptoParams;
